var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GlobalHeader',{staticClass:"header",attrs:{"show-customer":false}}),_vm._v(" "),_c('EnvBar'),_vm._v(" "),_c('nuxt',{staticClass:"content"}),_vm._v(" "),_c('GlobalFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }